import { render, staticRenderFns } from "./SlideAdd.vue?vue&type=template&id=21f535d2&"
import script from "./SlideAdd.vue?vue&type=script&lang=js&"
export * from "./SlideAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports